import LoginModal from '@/components/common/Login/MainLogin/LoginModal'
import { NotificationPanel } from '@/components/common/NotificationPanel'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { useAuth, useIsLogin, useRouterContext } from '@/shared/context'
import { useAppDispatch } from '@/shared/redux/hooks'
import { setUserInfo } from '@/shared/redux/slices/appGlobal.slice'
import { Avatar, Col, Popover, Row, Space } from 'antd'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MenuUser from './MenuUser'
import './index.scss'

const TopHeader = () => {
  const dispatch = useAppDispatch()
  const { setRouterBefore: setRouterBeforeLogin } = useRouterContext()
  const { setIsLogin: setIsLoginContext } = useIsLogin()

  // State để quản lý modal đăng nhập
  const [_isLoginModalOpen, _setIsLoginModalOpen] = useState(false)
  const [pendingAction, setPendingAction] = useState<any>('')
  const { isLogin } = useAuth()
  const navigate = useNavigate()
  const isAdmin = false
  const [showLogin, setShowLogin] = useState(false)
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const handleLoginSuccess = (userInfo: any) => {
    setShowLogin(false)

    // Thực hiện action đã lưu trước đó

    setRouterBeforeLogin(pendingAction.type)
    navigate(pendingAction.route)
    setPendingAction(null)
    setIsLoginContext(userInfo)
    dispatch(setUserInfo(userInfo))
    window.location.reload()
  }
  return (
    <div className="d-flex-end">
      <Space size={20} align="center">
        {isLogin && <NotificationPanel />}
        {isLogin ? (
          <Popover content={<MenuUser />} trigger="hover" placement="bottomRight">
            <Row gutter={5} className="pointer account-infor-sumary-border">
              <Col>
                <div className="account-infor">
                  <div className="account-infor-sumary">
                    {!!userInfo?.fullName && (
                      <div className="account-infor-sumary-fullname">{userInfo.fullName}</div>
                    )}
                  </div>
                  <Avatar src={userInfo?.avatar} size={32} className="style-avt" />
                </div>
              </Col>
            </Row>
          </Popover>
        ) : (
          <>
            <ButtonCustom className="btn-login-header" onClick={() => setShowLogin(true)}>
              Đăng nhập
            </ButtonCustom>
            <LoginModal
              open={showLogin}
              onCancel={() => setShowLogin(false)}
              onLoginSuccess={handleLoginSuccess}
              setOpenForgetPassModal={() => {
                setShowLogin(false)
              }}
            />
          </>
        )}
      </Space>
    </div>
  )
}

export default TopHeader
